import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";

export type RouteGuideActivityLogRow = {
  changedAt: string;
  zip: string;
  state: string;
  terminal: string;
  previousValue: string;
  newValue: string;
  action: string;
  modifiedBy: string;
  details: string;
};

const columnHelper = createColumnHelper<RouteGuideActivityLogRow>();

const getRouteGuideActivityLogColumns = () => [
  columnHelper.accessor("zip", {
    id: "zip",
    header: "ZIP",
    enableColumnFilter: false,
    size: 70,
  }),
  columnHelper.accessor("state", {
    id: "state",
    header: "State",
    enableColumnFilter: false,
    size: 120,
  }),
  columnHelper.accessor("terminal", {
    id: "terminal",
    header: "Terminal",
    enableColumnFilter: false,
    size: 160,
  }),
  columnHelper.accessor("previousValue", {
    id: "previousValue",
    header: "Previous Value",
    enableColumnFilter: false,
    size: 140,
  }),
  columnHelper.accessor("newValue", {
    id: "newValue",
    header: "New Value",
    enableColumnFilter: false,
    size: 140,
  }),
  columnHelper.accessor("action", {
    id: "action",
    header: "Action",
    cell: (cellProps) => {
      const action = String(cellProps.getValue() ?? "").toUpperCase();
      const actionColorMap: Record<string, TagColor> = {
        UPDATE: TagColor.ORANGE,
        CREATE: TagColor.GREEN,
        DELETE: TagColor.RED,
      };
      return (
        <Tag mods={{ color: actionColorMap[action] || TagColor.GREY }}>{action}</Tag>
      );
    },
    enableColumnFilter: false,
    size: 90,
  }),
  columnHelper.accessor("modifiedBy", {
    id: "modifiedBy",
    header: "Changed By",
    enableColumnFilter: false,
    size: 140,
  }),
  columnHelper.accessor("changedAt", {
    id: "changedAt",
    header: "Timestamp",
    cell: (cellProps) => {
      const value = cellProps.getValue();
      if (!value) return "—";
      return (
        <div className="xgs-route-guide-activitylog__date">
          <div>{(value as any).toUiDateFormat?.() ?? String(value)}</div>
          <div className="xgs-route-guide-activitylog__formatedtime">
            {(value as any).toUiTimeShortFormat?.() ?? ""}
          </div>
        </div>
      );
    },
    enableColumnFilter: false,
    size: 120,
  }),
  columnHelper.accessor("details", {
    id: "details",
    header: "Details",
    enableColumnFilter: false,
    size: 180,
  }),
];

export default getRouteGuideActivityLogColumns;
